import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  item: {
    display: 'flex',
    flexFlow: 'column',

    backgroundColor: theme.palette.action.hover,
    borderRadius: '0 30px',
    height: '100%',
    padding: theme.spacing(3),
  },
  title: {
    fontSize: 16,
    margin: 0,

    '&::after': {
      borderBottom: `2px solid ${theme.palette.primary.main}`,
      content: '""',
      display: 'block',
      margin: '2px 0 5px',
      width: 100,
    },
  },
  subtitle: {
    color: theme.palette.text.disabled,
    fontSize: 16,
    fontWeight: 'normal',
    margin: 0,
  },
  banner: {
    position: 'relative',
    paddingBottom: '70%',
    margin: `${theme.spacing(2)}px 0`,

    '& img': {
      position: 'absolute',
      borderRadius: theme.spacing(1),
      objectFit: 'cover',
      height: '100%',
      width: '100%',
    },
  },
  content: {
    flex: 1,
  },
}));

export default useStyles;
